<template>
  <div>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Photos</md-dialog-title>

      <md-dialog-content>
        <div class="ccic-photos-container">
          <div :key="getPhotoWrapperKey(w)" v-for="w in getPhotoWrapperList">
            <ccic-photo :photo="w.photo" :photoMeta="w.meta" :do-photo-upload="doPhotoUpload"/>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  .ccic-photos-container {
    min-width: 800px;
  }

  .md-dialog-content {
    padding: 8px;
  }
</style>
<script>
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import CcicPhoto from "./CcicPhoto.vue";

  export default {
    props: {
      onDataRefresh: Function,
    },
    components: { CcicPhoto },
    data: () => ({
      showDialog: false,
      photoZipFileName: '',
      parentSeqNo: '',
      parentType: '',
      photos: [],
      hasPhotoChanged: false,
      photoMeta: [],
      getPhotoRequest: null,
    }),
    computed: {
      ...mapGetters([
        'getUserProfile',
      ]),
      getPhotoWrapperList() {
        return this.photoMeta.map(meta => {
          const photo = this.getPhotoForKey(meta.key);
          if (photo) {
            photo.photoUrl = `${photo.photoUrl}?t=${moment(photo.updatedAt)
              .unix()}`;
          }
          return {
            meta,
            photo,
          };
        });
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          console.log(`1`);
          if (this.hasPhotoChanged) {
            this.onDataRefresh();
          }
          console.log(`2`);
          this.photoMeta = [];
          this.photos = [];
          this.hasPhotoChanged = false;
          this.$store.commit('clearApiError');
        }
      },
    },
    methods: {
      async openDialog(photoZipFileName, parentSeqNo, parentType, photoMeta, getPhotoRequest) {
        this.photoZipFileName = photoZipFileName;
        this.parentSeqNo = parentSeqNo;
        this.parentType = parentType;
        this.photoMeta = photoMeta;
        this.showDialog = true;
        this.getPhotoRequest = getPhotoRequest;
        this.hasPhotoChanged = true;
        this.photos = await this.getPhoto();
      },
      getPhotoForKey(key) {
        return _(this.photos)
          .find(it => it.photoKey === key);
      },
      async doPhotoUpload(request) {
        request.parentSeqNo = this.parentSeqNo;
        request.parentType = this.parentType;
        request.image.folder = `CCIC/${this.parentSeqNo}`;
        //await api.post('/api/w/ccic/photo/save', request);
        await newAPIPost('/api/w/ccic/photo/save', request);
        this.photos = await this.getPhoto();
      },
      getPhotoWrapperKey(w) {
        if (w.photo) {
          return `${w.meta.key}-${moment(w.photo.updatedAt)
            .format()}`;
        }
        return w.meta.key;
      },
      getPhoto() {
        //return api.post('/api/w/ccic/photo/get', this.getPhotoRequest);
        return newAPIPost('/api/w/ccic/photo/get', this.getPhotoRequest);
      },
    },
  };


</script>
